<template>
  <div id="app">
    <div id="page-container">
      <Header v-if="!$route.meta.hideHeader" />
      <div id="content-wrap">
        <router-view class="pt-3 pt-sm-4" :class="{ 'pl-0': !isMobile }" />
      </div>
      <footer id="footer">
        <Footer />
      </footer>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: { Footer, Header },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style lang="scss">
html,
body {
  font-family: 'Verdana' !important;
}

.multiselect__tag {
  background: #ff9a23 !important;
  .multiselect__tag-icon::after {
    filter: brightness(0) invert(1);
  }
}
.multiselect__option--highlight {
  background: #ff9a23 !important;
}
.multiselect__option:hover {
  background: #ff9a23 !important;
  color: #fff;
}
.statistics {
  border: 2px solid #e8a75c;
}
.first-div {
  background: #ff9a23;
  padding: 20px;
  h1 {
    color: #fff;
  }
}
.second-div {
  padding: 20px 60px;
  label {
    color: #ff9a23;
  }
}
p.text-danger {
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: 5px;
}
#page-container {
  position: relative;
  min-height: 100vh;
}
#content-wrap {
  padding-bottom: 300px;
}
#footer {
  //position: absolute;
  bottom: 0;
  width: 100%;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.no-text-decoration {
  &:hover {
    text-decoration: none;
  }
}
.no-radius {
  border-radius: 0px !important;
}
.no-pading {
  padding: 0px !important;
}
.no-margin {
  margin: 0px !important;
}

</style>
